/* Volti Games — menú lateral, respaldo del header fijo y toques en sugerencias del buscador */
(() => {
  const d = document;

  /* Sugerencias del buscador: en celular, al tocar un resultado el campo pierde el foco y la lista se oculta antes del "click".
     Se abre el resultado directamente al levantar el dedo (si no fue un desplazamiento). Con mouse, se evita que el campo pierda el foco. */
  let ts = null;
  d.addEventListener('touchstart', e => {
    const a = e.target.closest('.sugg a[href]');
    ts = a && !a.hasAttribute('data-q') ? { a, x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
  }, { passive: true, capture: true });
  d.addEventListener('touchmove', e => {
    if (!ts) return; const t = e.touches[0];
    if (Math.abs(t.clientX - ts.x) > 10 || Math.abs(t.clientY - ts.y) > 10) ts = null;
  }, { passive: true, capture: true });
  d.addEventListener('touchend', e => {
    if (!ts) return; const a = ts.a; ts = null;
    const href = a.getAttribute('href'); if (!href || href === '#') return;
    e.preventDefault(); location.href = a.href;
  }, { capture: true });
  d.addEventListener('mousedown', e => { if (e.target.closest('.sugg a[href]')) e.preventDefault(); }, true);

  /* Respaldo del header fijo: si el navegador no respeta position:sticky (algunos móviles), se fija con position:fixed y un espaciador */
  const hdr = d.getElementById('hdr');
  if (hdr) {
    let spacer = null, fixed = false, tk = false;
    const fix = on => {
      if (on === fixed) return; fixed = on;
      if (on) {
        spacer = spacer || d.createElement('div');
        spacer.style.height = hdr.offsetHeight + 'px';
        hdr.parentNode.insertBefore(spacer, hdr);
        Object.assign(hdr.style, { position: 'fixed', top: '0', left: '0', right: '0', width: '100%' });
      } else {
        if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
        ['position', 'top', 'left', 'right', 'width'].forEach(p => hdr.style.removeProperty(p));
      }
    };
    const check = () => {
      tk = false;
      if (!fixed) { if (scrollY > 10 && hdr.getBoundingClientRect().bottom <= 0) fix(true); }
      else if (spacer && spacer.getBoundingClientRect().top >= 0) fix(false);
    };
    addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(check); } }, { passive: true });
    addEventListener('resize', () => { if (fixed && spacer) spacer.style.height = hdr.offsetHeight + 'px'; }, { passive: true });
  }

  /* Menú lateral: se abre desde "Catálogo", se cierra con Escape o tocando afuera; las categorías se pliegan (una abierta a la vez) */
  const nav = d.getElementById('vgNav'); if (!nav) return;
  const panel = nav.querySelector('.nav__p'); let last = null;
  const setBtns = on => d.querySelectorAll('[data-nav-open]').forEach(b => b.setAttribute('aria-expanded', on));
  const open = () => {
    if (nav.classList.contains('is-open')) return;
    last = d.activeElement; nav.classList.add('is-open'); d.documentElement.classList.add('nav-open'); setBtns(true);
    setTimeout(() => { const x = nav.querySelector('.nav__x'); if (x) x.focus({ preventScroll: true }); }, 60);
  };
  const close = () => {
    if (!nav.classList.contains('is-open')) return;
    nav.classList.remove('is-open'); d.documentElement.classList.remove('nav-open'); setBtns(false);
    if (last && last.focus) last.focus({ preventScroll: true });
  };
  d.addEventListener('click', e => {
    if (e.target.closest('[data-nav-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-nav-close]')) close();
  });
  nav.addEventListener('keydown', e => {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const f = [...panel.querySelectorAll('a[href],button,summary')].filter(x => x.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  nav.querySelectorAll('.nav__g').forEach(g => g.addEventListener('toggle', () => {
    if (g.open) nav.querySelectorAll('.nav__g[open]').forEach(o => { if (o !== g) o.open = false; });
  }));
})();